// 在线吃瓜 - 事件复盘 mock 数据(虚构示例,用于静态展示)

export interface HotEvent {
  id: string;
  slug: string;
  title: string;
  category: string;
  tag: string;
  status: string;
  heat: number;
  cover: string;
  summary: string;
  duration: string;
  published: string;
  reads: string;
  comments: string;
}

export const heroCategories = [
  "全部",
  "商业财经",
  "娱乐八卦",
  "社会热点",
  "科技数码",
  "网络风波",
  "职场热议",
];

export const hotEvents: HotEvent[] = [
  {
    id: "e1",
    slug: "bakery-funding",
    title: "某烘焙品牌 A 轮融资风波始末",
    category: "商业财经",
    tag: "热门",
    status: "复盘完成",
    heat: 98,
    cover: "https://readdy.ai/api/search-image?query=moody%20cinematic%20artisan%20bakery%20storefront%20glowing%20warm%20window%20light%20at%20dusk%20terracotta%20and%20amber%20color%20palette%20inviting%20editorial%20brand%20story%20wide%20shot&width=1200&height=800&seq=chigua-hot-01&orientation=landscape",
    summary: "从一份流出的融资 PPT 到创始人深夜回应,我们完整梳理了事件发酵的 9 个关键节点,还原各方立场与背后的资本逻辑。",
    duration: "阅读约 12 分钟",
    published: "2026-08-28",
    reads: "32.6w",
    comments: "4.1k",
  },
  {
    id: "e2",
    slug: "talent-show-remarks",
    title: "选秀节目成员直播言论争议复盘",
    category: "娱乐八卦",
    tag: "热议",
    status: "复盘完成",
    heat: 95,
    cover: "https://readdy.ai/api/search-image?query=dramatic%20spotlit%20concert%20stage%20microphone%20silhouette%20warm%20amber%20glow%20editorial%20documentary%20photography%20moody%20atmosphere%20entertainment%20report&width=1200&height=800&seq=chigua-hot-02&orientation=landscape",
    summary: "一句话如何点燃舆论?我们把一次直播的完整前因、断章取义的多轮发酵,以及公司声明背后的博弈逐一还原。",
    duration: "阅读约 15 分钟",
    published: "2026-08-25",
    reads: "58.2w",
    comments: "9.7k",
  },
  {
    id: "e3",
    slug: "delivery-commission",
    title: "外卖平台佣金调整舆情全记录",
    category: "社会热点",
    tag: "追踪",
    status: "进行中",
    heat: 90,
    cover: "https://readdy.ai/api/search-image?query=moody%20city%20street%20delivery%20rider%20on%20motorcycle%20at%20night%20warm%20streetlight%20cinematic%20editorial%20social%20report%20fog%20atmosphere%20urban%20documentary&width=1200&height=800&seq=chigua-hot-03&orientation=landscape",
    summary: "佣金上调传闻落地前的一周,平台、商家与骑手各自经历了什么?时间线持续更新中。",
    duration: "阅读约 10 分钟",
    published: "2026-08-22",
    reads: "27.3w",
    comments: "3.5k",
  },
  {
    id: "e4",
    slug: "ai-reply-flop",
    title: "某 AI 回复翻车事件全流程复盘",
    category: "科技数码",
    tag: "反转",
    status: "已完结",
    heat: 88,
    cover: "https://readdy.ai/api/search-image?query=abstract%20glowing%20neural%20chip%20circuit%20warm%20amber%20orange%20tone%20futuristic%20technology%20editorial%20illustration%20dark%20elegant%20atmosphere%20high%20detail&width=1200&height=800&seq=chigua-hot-04&orientation=landscape",
    summary: "AI 客服一次看似普通的错误回复,如何演变成全网围观的技术与公关双重事件?我们还原了从诞生到道歉的完整链条。",
    duration: "阅读约 13 分钟",
    published: "2026-08-18",
    reads: "41.9w",
    comments: "6.2k",
  },
  {
    id: "e5",
    slug: "streamer-price-row",
    title: "头部主播自营店价格争议始末",
    category: "网络风波",
    tag: "热门",
    status: "复盘完成",
    heat: 86,
    cover: "https://readdy.ai/api/search-image?query=luxury%20retail%20storefront%20with%20close%20up%20price%20tag%20warm%20boutique%20lighting%20shallow%20depth%20editorial%20commerce%20report%20terracotta%20and%20amber%20tone&width=1200&height=800&seq=chigua-hot-05&orientation=landscape",
    summary: "同一商品不同直播间价格差异为何引发众怒?我们从比价截图出发,一层层厘清定价、分成与售后背后的是与非。",
    duration: "阅读约 11 分钟",
    published: "2026-08-15",
    reads: "36.8w",
    comments: "5.0k",
  },
  {
    id: "e6",
    slug: "office-hiring-dispute",
    title: "写字楼招聘改签争议时间线梳理",
    category: "职场热议",
    tag: "热议",
    status: "复盘完成",
    heat: 82,
    cover: "https://readdy.ai/api/search-image?query=corporate%20office%20interior%20with%20desks%20warm%20lamp%20light%20modern%20workplace%20editorial%20social%20report%20cinematic%20terracotta%20amber%20warm%20tone&width=1200&height=800&seq=chigua-hot-06&orientation=landscape",
    summary: "一份被改写的录用通知牵出招聘流程漏洞。我们把候选人与公司视角并排呈现,还原争议的来龙去脉。",
    duration: "阅读约 9 分钟",
    published: "2026-08-12",
    reads: "19.4w",
    comments: "2.8k",
  },
];

export interface TimelineNode {
  date: string;
  title: string;
  desc: string;
}

export const featureTimeline: TimelineNode[] = [
  {
    date: "2026.08.20",
    title: "疑似内部文件流出",
    desc: "深夜 23 点,一张融资 PPT 截图在行业群里流传,随后快速扩散到社交平台。舆论首次关注到该公司融资条款细节。",
  },
  {
    date: "2026.08.21",
    title: "多方解读与分歧",
    desc: "隔天上午,多个账号基于同一张截图得出相互矛盾的结论,「对赌」与「回购」两派解读开始分化,情绪逐渐升温。",
  },
  {
    date: "2026.08.22",
    title: "官方首次回应",
    desc: "品牌方发布首份声明,称「部分细节被误读」,但未公开完整条款,含糊表述反而引发第二轮追问。",
  },
  {
    date: "2026.08.24",
    title: "创始人深夜长文",
    desc: "创始人在凌晨发出长篇回应,回忆创业历程并说明融资初衷。长文中的一句感慨再度被截取放大,讨论达到峰值。",
  },
  {
    date: "2026.08.26",
    title: "专业口径澄清",
    desc: "行业媒体与投资圈人士陆续从专业角度解释条款含义,舆论热度开始回落,关注点转向「信息核实」本身。",
  },
  {
    date: "2026.08.28",
    title: "事件复盘归档",
    desc: "我们综合信源,按时间线完整还原事件始末,区分事实、传闻与观点,把这场融资风波的完整脉络呈现给读者。",
  },
];

export interface MethodStep {
  no: string;
  title: string;
  desc: string;
  icon: string;
}

export const methodSteps: MethodStep[] = [
  {
    no: "01",
    title: "完整时间线梳理",
    desc: "逐条核对信息发布时间与信源可靠性,把零散碎片拼成可读的时间轴,不让任何关键节点被遗漏。",
    icon: "ri-time-line",
  },
  {
    no: "02",
    title: "前因后果背景解析",
    desc: "把事件放回行业与语境里看,理清利益相关方、历史矛盾与外部环境,回答「为什么会这样」的问题。",
    icon: "ri-node-tree",
  },
  {
    no: "03",
    title: "深度复盘与结论",
    desc: "区分事实、传闻与观点,标注证据边界,给出克制而清晰的分析,让读者自己也能形成判断。",
    icon: "ri-search-eye-line",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "在线吃瓜如何保证事件信息的真实性?",
    a: "我们会优先采用一手信源与官方声明,对二手信息标注来源并在时间线中区分「已证实」「传闻」「待核实」三类状态。凡涉及专业条款或事实争议,均附信源链接供读者自行核对,不替读者下结论。",
  },
  {
    q: "为什么部分复盘事件不直接点名具体当事人?",
    a: "复盘关注的是事件本身的逻辑与传播规律,而非对个人的评价。为保护个人隐私并避免信息不完整时造成误导,部分案例会做脱敏处理,仅保留对理解事件真正重要的信息。",
  },
  {
    q: "「完整时间线」里的事件是否都是最终版本?",
    a: "不是。进行中的事件我们会持续跟进并在时间线末尾标注「更新中」,一旦出现新的关键节点或官方说法,会及时修订补充,并在文中注明最后更新时间。",
  },
  {
    q: "读者可以通过哪些方式参与讨论或提供线索?",
    a: "每篇复盘下方都开放评论区,我们也在站内提供线索投稿入口。若你掌握了一手资料,欢迎在提交时附上可核验的出处,审核通过后我们会谨慎纳入时间线分析。",
  },
  {
    q: "为什么坚持区分「事实」与「观点」?",
    a: "吃瓜最怕以讹传讹。我们相信只有把已发生的事实与各方主观评价清楚分开,读者才能看清事件全貌、不被单方面叙事带偏,这也是「前因后果背景解析」的价值所在。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "阿禾",
    role: "互联网行业从业者",
    text: "看了你们对那场融资风波的复盘,时间线非常清楚,连我这种身在行业里的人都没意识到中间漏了那么多关键节点。",
  },
  {
    name: "小鹿乱撞",
    role: "吃瓜多年老粉",
    text: "最喜欢的是「前因后果」那部分,终于有人把来龙去脉讲明白了。以前只看到表面热闹,现在能自己理清整件事了。",
  },
  {
    name: "一颗卷心菜",
    role: "在校研究生",
    text: "对事实和观点分开标注这点很加分,读起来很安心,不会被单方面带节奏。希望继续保持这种克制的风格。",
  },
];

export interface MediaCard {
  title: string;
  category: string;
  reads: string;
  time: string;
  excerpt: string;
  cover: string;
}

export const mediaPicks: MediaCard[] = [
  {
    title: "从一句回应到全网反转:复盘舆论场的三次「翻车」瞬间",
    category: "深度复盘",
    reads: "21.5w",
    time: "08-30",
    excerpt: "为什么同样的回应在不同语境下结果截然不同?我们拆解了三次代表性案例中的措辞、节奏与受众情绪。",
    cover: "https://readdy.ai/api/search-image?query=newspaper%20collage%20texture%20with%20torn%20paper%20headlines%20warm%20amber%20editorial%20journalism%20moody%20art%20design%20abstract%20storytelling&width=800&height=600&seq=chigua-media-01&orientation=landscape",
  },
  {
    title: "比价截图为何总能引爆?价格争议背后的传播密码",
    category: "传播解析",
    reads: "16.8w",
    time: "08-27",
    excerpt: "一张截图、一个差价,就能点燃全网情绪。我们从信息经济学角度看看「比价瓜」屡屡刷屏的深层原因。",
    cover: "https://readdy.ai/api/search-image?query=receipt%20price%20tag%20close%20up%20warm%20desk%20lamp%20moody%20editorial%20consumer%20finance%20news%20abstract%20composition%20terracotta%20amber&width=800&height=600&seq=chigua-media-02&orientation=landscape",
  },
  {
    title: "声明文字背后的博弈:五份公开回应的修辞分析",
    category: "文本拆解",
    reads: "13.2w",
    time: "08-24",
    excerpt: "措辞是留白还是含糊?句式的选择藏着怎样的策略?我们对比五份公开声明,读出字里行间的潜台词。",
    cover: "https://readdy.ai/api/search-image?query=old%20typewriter%20with%20paper%20documents%20warm%20cinematic%20light%20editorial%20literature%20text%20analysis%20moody%20atmosphere%20vintage&width=800&height=600&seq=chigua-media-03&orientation=landscape",
  },
  {
    title: "「进行中」的瓜要不要追?聊聊追更与吃瓜心态",
    category: "观点",
    reads: "9.6w",
    time: "08-21",
    excerpt: "当事件尚未尘埃落定,过早站队往往容易被打脸。这篇聊聊理性围观的意义与边界。",
    cover: "https://readdy.ai/api/search-image?query=person%20looking%20at%20smartphone%20glow%20at%20night%20warm%20street%20light%20moody%20thoughtful%20editorial%20lifestyle%20documentary%20urban&width=800&height=600&seq=chigua-media-04&orientation=landscape",
  },
];

export interface TimelineGuide {
  key: string;
  label: string;
  desc: string;
  count: string;
}

export const timelineGuides: TimelineGuide[] = [
  { key: "shangye", label: "商业瓜田", desc: "融资、并购与公司舆论事件始末", count: "86 篇" },
  { key: "yule", label: "娱乐圈", desc: "艺人、综艺与粉丝生态复盘", count: "124 篇" },
  { key: "shehui", label: "社会议题", desc: "公共事件的多方视角解析", count: "67 篇" },
  { key: "keji", label: "科技风波", desc: "产品、AI 与平台争议追踪", count: "53 篇" },
  { key: "wangluo", label: "网络名场面", desc: "直播、段子与舆论翻车现场", count: "79 篇" },
];